import { Controller as BaseController } from 'stimulus'
import './index.scss'

export class Controller extends BaseController {
  static targets = ['self', 'form', 'textArea', 'liveRegion', 'submit', 'characterCount'];
  static values = {
    errorMessage: String,
    charLimit: String
  }

  static classes = ['error']

  edit(event) {
    this.selfTarget.classList.add(event.currentTarget.dataset.editingClass)
  }

  cancel(event) {
    this.formTarget.reset()
    this.selfTarget.classList.remove(event.currentTarget.dataset.editingClass)
  }

  validateCharacterLimit() {
    let error = ''
    let saveBtnDisabled = false
    if (this.textAreaTarget.textLength > this.charLimitValue) {
      error = this.errorMessageValue
      saveBtnDisabled = true
    }
    this.submitTarget.disabled = saveBtnDisabled
    this.updateCharacterCount()
    $(this.liveRegionTarget).text(error)
  }

  updateCharacterCount() {
    const currentCharCount = this.charLimitValue - this.textAreaTarget.textLength
    if (currentCharCount < 0) {
      $(this.textAreaTarget).blur()
      $(this.characterCountTarget).addClass('c-atomic--organism--editable-text-area-error')
      $(this.textAreaTarget).addClass('c-atomic--organism--editable-text-area-error-text-area')
      $('.c-atomic--atom--textarea-label__content').addClass('c-atomic--organism--editable-text-area-error')
    } else {
      $(this.characterCountTarget).removeClass('c-atomic--organism--editable-text-area-error')
      $(this.textAreaTarget).removeClass('c-atomic--organism--editable-text-area-error-text-area')
      $('.c-atomic--atom--textarea-label__content').removeClass('c-atomic--organism--editable-text-area-error')
    }
    $(this.characterCountTarget).text((currentCharCount + ' characters remaining'))
  }
}
